import { Modal } from '@mantine/core'

export default {
    Modal: Modal.extend({
        defaultProps: {
            radius: 'md',
        }
    })
}